import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, Alert, ModalFooter } from 'reactstrap';
import { Storage, Translate, translate } from 'react-jhipster';
import '../../user/profile.scss';
import '../../../sendOtp/sendOtp.scss';
import OtpInput from 'react-otp-input';
import moment from 'moment';
import { AddApp, getQRCode } from '../user.reducer';
import { ERROR, SUCCESS } from 'app/config/constants';
import SuccessModal from 'app/modules/administration/approve-management/modal/success-modal';

export interface IAuthAddAppProps extends StateProps, DispatchProps {
  modalShow: boolean;
  handleClose: Function;
}

export interface IAuthAddAppState {
  visible: boolean;
  color: string;
  message: string;
  isDisable: boolean;
  redirectUrl: boolean;
  alertMess: string;
  isOpenAlert: boolean;
  totp: string;
  showSecret: boolean;
  otpValue: string;
  showSuccessModal: boolean;
}

export class AuthAddApp extends React.Component<IAuthAddAppProps, IAuthAddAppState> {
  state: IAuthAddAppState = {
    visible: false,
    color: 'info',
    message: '',
    isDisable: false,
    redirectUrl: false,
    alertMess: '',
    isOpenAlert: false,
    totp: '',
    showSecret: false,
    otpValue: '',
    showSuccessModal: false
  };

  componentDidMount() {}

  componentDidUpdate(prevProps: Readonly<IAuthAddAppProps>): void {
    const { resAddApp } = this.props;
    if (!resAddApp || prevProps.resAddApp !== resAddApp) {
      if (resAddApp && resAddApp.status === SUCCESS) {
        this.setState({ showSuccessModal: true });
        let timerId = setTimeout(() => {
          this.setState({ showSuccessModal: false });
          this.toggle();
        }, 3000);
      } else if (resAddApp && resAddApp.status === ERROR) {
        this.setState({
          visible: true,
          color: 'danger',
          message: resAddApp.message
        });
      }
    }
  }

  toggle = () => {
    this.props.handleClose();
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  // toggleShowSecret = () => {
  //     const { showSecret } = this.state;
  //     if (!showSecret) {
  //         this.props.getQRCode();
  //     }
  //     this.setState(prevState => ({
  //         showSecret: !prevState.showSecret
  //     }));
  // };

  handleOtpChange = event => {
    this.setState({
      otpValue: event.target.value
    });
  };

  onFinish = () => {
    if (this.state.otpValue) {
      this.props.AddApp(this.state.otpValue);
    }
  };

  handleSuccessClose = () => {
    const { showSuccessModal } = this.state;
    if (showSuccessModal) {
      this.setState({
        showSuccessModal: false
      });
    }
  };

  render() {
    return (
      <div className="container-fluid">
        <Modal
          className="modal-lg hide-border-bottom-modal"
          isOpen={this.props.modalShow}
          toggle={this.toggle}
          size="lg"
          backdrop="static"
          centered={window.location === window.parent.location}
          style={{ maxWidth: window.innerWidth < 768 ? '90%' : '45%' }}
        >
          <ModalHeader toggle={this.toggle}>
            <h3 className="font-weight-bold">Kích hoạt ứng dụng xác thực</h3>
          </ModalHeader>
          <ModalBody
            className="custom-scrollbar"
            style={{
              paddingTop: '0px',
              paddingLeft: '2%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <SuccessModal
              showSuccessModal={this.state.showSuccessModal}
              message="Bổ sung phương thức xác thực qua Ứng dụng thành công!"
              handleClose={this.handleSuccessClose}
            />
            <p>Quét mã QR hoặc nhập mã bí mật để sử dụng TOTP</p>

            <div style={{ textAlign: 'center' }}>
              <img src={this.props.qrCodeUrl} alt="QR Code" style={{ width: '200px', height: '200px' }} />
            </div>

            {/* <div className="mt-3" style={{ display: 'flex', justifyContent: 'center' }}>
                            <button type="button" className="btn btn-link" onClick={this.toggleShowSecret}>Hiển thị mã bí mật</button>
                        </div> */}

            <div className="mt-3">
              <OtpInput
                inputStyle={{
                  width: '2.5rem',
                  height: '2.5rem',
                  margin: '5px 5px',
                  fontSize: '1.5rem',
                  border: '1px solid rgba(0,0,0,0.3)'
                }}
                numInputs={6}
                onChange={otpValue => this.setState({ otpValue })}
                value={this.state.otpValue}
                shouldAutoFocus
                containerStyle={{ justifyContent: 'center' }}
              />
            </div>

            <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
            <Button className="btnSignGreen" onClick={this.onFinish}>
              Xác minh
            </Button>
            <Button className="btnSign" onClick={this.toggle}>
              Hủy
            </Button>
          </ModalBody>
          <ModalFooter>
            <div className="mt-4" style={{ backgroundColor: '#f8f9fa' }}>
              <strong>*Thiết lập ứng dụng xác thực</strong>
              <p>Bước 1: Tải ứng dụng VNPT Authenticator, nhấn dấu (+), chọn Quét mã QR</p>
              <p>Bước 2: Thực hiện quét mã QR tại màn hình (Nếu không thể quét mã, có thể Nhập từ khóa thiết lập)</p>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  loading: storeState.userInfo.loading,
  qrCodeUrl: storeState.userInfo.qrCodeUrl,
  resAddApp: storeState.userInfo.resAddApp,
  errorMessage: storeState.userInfo.errorMessage
});
const mapDispatchToProps = {
  getQRCode,
  AddApp
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthAddApp);
